import { combineReducers } from 'redux';

import { tripsTabReducer } from './containers/TripsTabContainer/reducer';
import { tripReducer } from './containers/TripContainer/services/reducer';
import { reportPhotoReducer } from './containers/ReportsContainer/services/reducer';
import { reportsReducer } from './reports/reportsReducer';

export const securityModuleReducer = combineReducers({
  tripsTabReducer,
  tripReducer,
  reportsReducer,
  reportPhotoReducer,
});

export type SecurityModuleState = ReturnType<typeof securityModuleReducer>;
